import { buildMetadata as generatedBuildMetadata } from '@/__generated__/build-metadata';

export type BuildMetadata = Readonly<{
    revision: string;
}>;

export const buildMetadata = Object.freeze({
    revision: generatedBuildMetadata.revision,
}) satisfies BuildMetadata;
